import { compact, isEmpty, reduce, some } from 'lodash/fp';

import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';
import type { Section, SectionAwardType } from '../../types';

const reduceWithIndex = uncapFpIterator(reduce);

// @ts-expect-error - Automatic, Please fix when editing this file
const INITIAL_VALUE = [];
const MAX_AWARD_TILES = 2;
const SPACE_BETWEEN_TILES = 3;

type InsertAwardTiles = {
  awardTiles: SectionAwardType[];
  sections: Section[];
};

/*
 * Insert award tiles into the sections array at a fixed interval.
 * The interval is defined by the SPACE_BETWEEN_TILES constant.
 * The maximum number of award tiles to insert is defined by the MAX_AWARD_TILES constant.
 * The awards will sit after the promo banner if it exists. If not they will sit after the first section.
 */
const insertAwardTiles = ({ awardTiles, sections }: InsertAwardTiles): Section[] => {
  if (isEmpty(awardTiles)) {
    return sections;
  }

  const limitedAwardTiles = awardTiles.slice(0, MAX_AWARD_TILES);
  const hasPromoBanner = some({ type: 'offerStrip' }, sections);

  const sectionsWithAwardTiles = reduceWithIndex(
    (sectionsWithAwards: Section[], section: Section, index: number) => {
      const startingPosition = hasPromoBanner ? 2 : 1;
      const newIndex = index + 1;
      const relativePositionFromStart = newIndex - startingPosition;
      const shouldAddAward = relativePositionFromStart % SPACE_BETWEEN_TILES === 0;
      const indexOfAward = Math.floor(relativePositionFromStart / SPACE_BETWEEN_TILES);
      const awardToAdd = shouldAddAward ? limitedAwardTiles[indexOfAward] : null;

      return [...sectionsWithAwards, section, ...(awardToAdd ? [awardToAdd] : [])];
    },
    // @ts-expect-error - Automatic, Please fix when editing this file
    INITIAL_VALUE,
    sections,
  );
  return compact(sectionsWithAwardTiles);
};

export default insertAwardTiles;
